module.exports = require('./src/tecactus-api').default;